import React from 'react';

const ConfigSection = ({ config, handleConfigChange, tipoDocumento }) => {
  return (
    <div className="config-section">
      <h3>⚙️ Configurações</h3>
      <div className="config-fields">
        <div className="form-group">
          <label className="field-label"><span>👨‍💼</span> Nome do Advogado</label>
          <input
            type="text"
            value={config.advogado}
            onChange={(e) => handleConfigChange('advogado', e.target.value)}
            placeholder="Nome completo do advogado"
            className="config-input"
          />
        </div>
        <div className="form-group">
          <label className="field-label"><span>🏛️</span> Número OA</label>
          <input
            type="text"
            value={config.oa}
            onChange={(e) => handleConfigChange('oa', e.target.value)}
            placeholder="Número da Ordem dos Advogados"
            className="config-input"
          />
        </div>
        <div className="form-group">
          <label className="field-label"><span>📍</span> Domicílio</label>
          <input
            type="text"
            value={config.domicilio}
            onChange={(e) => handleConfigChange('domicilio', e.target.value)}
            placeholder="Endereço completo"
            className="config-input"
          />
        </div>
        <div className="form-group">
          <label className="field-label"><span>🌐</span> API Base URL</label>
          <input
            type="text"
            value={config.apiBaseUrl}
            onChange={(e) => handleConfigChange('apiBaseUrl', e.target.value)}
            placeholder="URL base da API"
            className="config-input"
          />
        </div>
        {tipoDocumento === 'procuracao' && (
          <div className="config-row">
            <div className="form-group">
              <label className="field-label"><span>🤖</span> Modelo Identificar Dados</label>
              <select
                value={config.modeloIdentificarDados}
                onChange={(e) => handleConfigChange('modeloIdentificarDados', e.target.value)}
                className="config-select"
              >
                <option value="gpt-4o-mini">GPT-4o Mini</option>
                <option value="gpt-4o">GPT-4o</option>
              </select>
            </div>
            <div className="form-group">
              <label className="field-label"><span>📝</span> Modelo Criar Procuração</label>
              <select
                value={config.modeloCriarProcuracao}
                onChange={(e) => handleConfigChange('modeloCriarProcuracao', e.target.value)}
                className="config-select"
              >
                <option value="o1-mini">O1 Mini</option>
                <option value="gpt-4o">GPT-4o</option>
              </select>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConfigSection;
